import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-candidate',
  templateUrl: './candidate.component.html',
  styleUrls: ['./candidate.component.scss']
})
export class CandidateComponent implements OnInit {

  constructor(public app: AppComponent) {}

  ngOnInit() {
    this.app.onLayoutClick();
  }

}



// WEBPACK FOOTER //
// ./src/app/candidate/candidate.component.ts